const externalSelectConfig = {
  development: {
    '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3': {
      type: 'getYears',
      requestField: 'vehicle_year',
      requiresDataFrom: [
        'f5631693-1fa6-11ec-a6b2-062f1bcd6de3',
        '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3',
      ],
    },
    'f5631693-1fa6-11ec-a6b2-062f1bcd6de3': {
      type: 'getMakes',
      requestField: 'vehicle_make',
      requiresDataFrom: [
        '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3',
        '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3',
      ],
    },
    '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3': {
      type: 'getModels',
      requestField: 'vehicle_model',
      requiresDataFrom: [
        '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3',
        'f5631693-1fa6-11ec-a6b2-062f1bcd6de3',
      ],
    },
  },
  staging: {
    '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3': {
      type: 'getYears',
      requestField: 'vehicle_year',
      requiresDataFrom: [
        'f5631693-1fa6-11ec-a6b2-062f1bcd6de3',
        '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3',
      ],
    },
    'f5631693-1fa6-11ec-a6b2-062f1bcd6de3': {
      type: 'getMakes',
      requestField: 'vehicle_make',
      requiresDataFrom: [
        '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3',
        '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3',
      ],
    },
    '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3': {
      type: 'getModels',
      requestField: 'vehicle_model',
      requiresDataFrom: [
        '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3',
        'f5631693-1fa6-11ec-a6b2-062f1bcd6de3',
      ],
    },
  },
  'production-eu': {
    '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3': {
      type: 'getYears',
      requestField: 'vehicle_year',
      requiresDataFrom: [
        'f5631693-1fa6-11ec-a6b2-062f1bcd6de3',
        '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3',
      ],
    },
    'f5631693-1fa6-11ec-a6b2-062f1bcd6de3': {
      type: 'getMakes',
      requestField: 'vehicle_make',
      requiresDataFrom: [
        '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3',
        '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3',
      ],
    },
    '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3': {
      type: 'getModels',
      requestField: 'vehicle_model',
      requiresDataFrom: [
        '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3',
        'f5631693-1fa6-11ec-a6b2-062f1bcd6de3',
      ],
    },
  },
  'production-na': {
    '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3': {
      type: 'getYears',
      requestField: 'vehicle_year',
      requiresDataFrom: [
        'f5631693-1fa6-11ec-a6b2-062f1bcd6de3',
        '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3',
      ],
    },
    'f5631693-1fa6-11ec-a6b2-062f1bcd6de3': {
      type: 'getMakes',
      requestField: 'vehicle_make',
      requiresDataFrom: [
        '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3',
        '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3',
      ],
    },
    '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3': {
      type: 'getModels',
      requestField: 'vehicle_model',
      requiresDataFrom: [
        '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3',
        'f5631693-1fa6-11ec-a6b2-062f1bcd6de3',
      ],
    },
  },
  test: {
    '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3': {
      type: 'getYears',
      requestField: 'vehicle_year',
      requiresDataFrom: [
        'f5631693-1fa6-11ec-a6b2-062f1bcd6de3',
        '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3',
      ],
    },
    'f5631693-1fa6-11ec-a6b2-062f1bcd6de3': {
      type: 'getMakes',
      requestField: 'vehicle_make',
      requiresDataFrom: [
        '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3',
        '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3',
      ],
    },
    '76c9798f-1fa7-11ec-a6b2-062f1bcd6de3': {
      type: 'getModels',
      requestField: 'vehicle_model',
      requiresDataFrom: [
        '7d3494c0-1fa6-11ec-a6b2-062f1bcd6de3',
        'f5631693-1fa6-11ec-a6b2-062f1bcd6de3',
      ],
    },
  },
};

export default externalSelectConfig;
